import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService, ContextService, CartService } from '../../services';
import { User } from '../../models';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  status:boolean = false;
  compte:boolean = true;
  admin:boolean = false;
  ressources:boolean = false;
  isWrong:boolean = false;
  isWrongSite: boolean = false;
  context: string;
  context_route: string;
  id:string;
  pw:string;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  modalRef3: BsModalRef;
  modalRef4: BsModalRef;
  loggedTemplate: TemplateRef<any>;
  logged_modal: boolean = false;
  auth_error: string;
   area: string;

  constructor(
    private userService: UserService,
    private cartService: CartService,
    private contextService: ContextService,
    private modalService: BsModalService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.context = this.contextService.getContext();
    this.context_route = (this.context == 'B2B') ? '' : '/familles';

      this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
          let url =ev.url.split("/");
          this.context = (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          this.context_route=(this.context=='B2B')?'':'/familles';
        
        }
          
     });


  }

  toggleWindow(){
    this.context = this.contextService.getContext();
    this.context_route = (this.context == 'B2B') ? '' : '/familles';
  	this.status = !this.status;
  }

  onSubmit(data){
    this.isWrong = false;
    let credentials = {
      login: this.id,
      password: this.pw
    };

    this.userService.attemptAuth('', credentials)
      .subscribe(data => {
        // console.log(data);
        if(data == 'wrong_site'){
          this.isWrongSite = true;
        } else {
          this.isWrongSite = false;
          this.openModal4(this.loggedTemplate);
          this.hideModals();
        }
    }, error => {
      // console.log(error[0])
     if(error[0]) this.auth_error = error[0].Message;
      this.isWrong = true;
    });
  }

  hideModals(){
    if(this.modalRef != undefined) this.modalRef.hide();
    if(this.modalRef2 != undefined) this.modalRef2.hide();
    if(this.modalRef3 != undefined) this.modalRef3.hide();
  }

  goToAdmin(){
    this.compte = false;
    this.ressources = false;
    this.admin = true;
  }

  goToRessources(){
    this.admin = false;
    this.compte = false;
    this.ressources = true;
  }

  goToCompte(){
    this.ressources = false;
    this.admin = false;
    this.compte = true;
  }

  redirected(){
    this.isWrongSite = false;
    this.cartService.destroyLocalCart();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  openModal2(template: TemplateRef<any>) {
    this.modalRef3.hide();
    this.modalRef2 = this.modalService.show(template, { class: 'second' });
  }

  openModal3(template: TemplateRef<any>) {
    this.modalRef2.hide();
    this.modalRef3 = this.modalService.show(template, { class: 'second' });
  }

  openModal4(template: TemplateRef<any>) {
    // this.hideModals();

    this.modalRef4 = this.modalService.show(template);
  }

  saveTemplate(template: TemplateRef<any>){
    this.loggedTemplate = template;

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/_login/login.component.ts